export const statePaymentsOptions = [
  { value: 'show_all', label: 'dashboard_payment_show_all' },
  { value: 'created', label: 'dashboard_payment_created' },
  { value: 'extended', label: 'dashboard_payment_extended' },
  { value: 'paid', label: 'dashboard_payment_paid' },
  { value: 'partial_refund', label: 'dashboard_payment_partial_refund' },
  { value: 'refund', label: 'dashboard_payment_full_refund' },
  { value: 'cancelled', label: 'dashboard_payment_cancelled' },
  { value: 'expired', label: 'dashboard_payment_expired' },
  { value: 'error', label: 'dashboard_payment_paid_error' },
]